"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionToolbar = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ActionToolbar = function (_a) {
    var content = _a.content, sticky = _a.sticky, className = _a.className;
    var actionToolbarSticky = sticky !== null && sticky !== void 0 ? sticky : false;
    var ActionToolbarClasses = classnames_1.default('Page__actionToolbar', className, {
        'Page__actionToolbar--sticky': actionToolbarSticky,
    });
    return react_1.default.createElement("div", { className: ActionToolbarClasses }, content);
};
exports.ActionToolbar = ActionToolbar;
//# sourceMappingURL=ActionToolbar.js.map